module.exports = __webpack_public_path__ + "static/media/review_02.66ec09c4.mp4";